<script>
import { BLink } from "bootstrap-vue-next";
import { layoutComputed } from "@/state/helpers";
export default {
  components: {
    BLink,
  },
  props: {
    menuItems: {
      type: Array,
    },
    isParent:{
      type: Boolean,
    },
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
      lsmenu: [],
    };
  },
  computed: {
    ...layoutComputed,
    layoutType: {
      get() {
        return this.$store ? this.$store.state.layout.layoutType : {};
      },
    },
  },

  watch: {
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    this.initActiveMenu();
    if (this.rmenu === "vertical" && this.layoutType === "twocolumn") {
      document.documentElement.setAttribute("data-layout", "vertical");
    }
    document.getElementById("overlay").addEventListener("click", () => {
      document.body.classList.remove("vertical-sidebar-enable");
    });
    window.addEventListener("resize", () => {
      if (this.layoutType === "twocolumn") {
        const windowSize = document.documentElement.clientWidth;
        if (windowSize < 767) {
          this.setLayout("vertical");
        } else {
          this.setLayout("twocolumn");
        }
      }
    });
    document.querySelectorAll(".navbar-nav .collapse").forEach((collapse) => {
      collapse.addEventListener("show.bs.collapse", this.handleShowCollapse);
      collapse.addEventListener("hide.bs.collapse", this.handleHideCollapse);
    });
  },

  methods: {
    // Backend Feather ikon adını ("UsersIcon") font-awesome formatına çevirir (["fas","users"]).
    getFaIcon(icon) {
      if (!icon) return null;
      if (Array.isArray(icon)) return icon;
      if (icon.includes("fa-") || icon.includes(" ")) return icon;
      const name = icon
        .replace(/Icon$/, "")
        .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
        .toLowerCase();
      return ["fas", name];
    },
    onRoutechange() {
      this.initActiveMenu();
    },

    setLayout(type) {
      document.documentElement.setAttribute("data-layout", type);
      this.rmenu = type;
      localStorage.setItem("rmenu", type);
      if (type === "twocolumn") {
        setTimeout(() => {
          this.initActiveMenu();
        }, 50);
      }
    },
    handleShowCollapse(e) {
      e.stopPropagation();
      const closestCollapse = e.target.parentElement.closest(".collapse");
      if (closestCollapse) {
        this.hideSiblings(closestCollapse.querySelectorAll(".collapse"));
      } else {
        this.hideSiblings(this.getSiblings(e.target.parentElement));
      }
    },
    handleHideCollapse(e) {
      e.stopPropagation();
      e.target.querySelectorAll(".collapse").forEach((childCollapse) => {
        childCollapse.classList.remove("show");
        childCollapse.parentElement.setAttribute("aria-expanded", "false");
      });
    },
    hideSiblings(siblingCollapses) {
      siblingCollapses.forEach((siblingCollapse) => {
        if (siblingCollapse.classList.contains("show")) {
          siblingCollapse.classList.remove("show");
          siblingCollapse.parentElement.setAttribute("aria-expanded", "false");
        }
      });
    },
    getSiblings(elem) {
      let siblings = [];
      let sibling = elem.parentNode.firstChild;
      while (sibling) {
        if (sibling.nodeType === 1 && sibling !== elem) {
          siblings.push(sibling);
        }
        sibling = sibling.nextSibling;
      }
      return siblings;
    },

    initActiveMenu() {
      const pathName = window.location.pathname;
      const ul = document.getElementById("navbar-nav");
      if (ul) {
        const items = Array.from(ul.querySelectorAll("a.nav-link"));
        let activeItems = items.filter((x) => x.classList.contains("active"));
        this.removeActivation(activeItems);
        let matchingMenuItem = items.find((x) => {
          return x.getAttribute("href") === pathName;
        });
        if (matchingMenuItem) {
          this.activateParentDropdown(matchingMenuItem);
        } else {
          let id = pathName.replace("/", "");
          if (id) document.body.classList.add("twocolumn-panel");
          this.activateIconSidebarActive(pathName);
        }
      }
    },
    removeActivation(items) {
      items.forEach((item) => {
        if (item.classList.contains("menu-link")) {
          if (!item.classList.contains("active")) {
            item.setAttribute("aria-expanded", false);
          }
          item.nextElementSibling.classList.remove("show");
        }
        if (item.classList.contains("nav-link")) {
          if (item.nextElementSibling) {
            item.nextElementSibling.classList.remove("show");
          }
          item.setAttribute("aria-expanded", false);
        }
        item.classList.remove("active");
      });
    },

    activateParentDropdown(item) {
      // navbar-nav menu add active
      item.classList.add("active");
      let parentCollapseDiv = item.closest(".collapse.menu-dropdown");
      if (parentCollapseDiv) {
        // to set aria expand true remaining
        parentCollapseDiv.classList.add("show");
        parentCollapseDiv.parentElement.children[0].classList.add("active");
        parentCollapseDiv.parentElement.children[0].setAttribute(
          "aria-expanded",
          "true"
        );
        if (
          parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")
        ) {
          if (
            parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")
              .previousElementSibling
          ) {
            if (
              parentCollapseDiv.parentElement
                .closest(".collapse.menu-dropdown")
                .previousElementSibling.parentElement.closest(
                  ".collapse.menu-dropdown"
                )
            ) {
              const grandparent = parentCollapseDiv.parentElement
                .closest(".collapse.menu-dropdown")
                .previousElementSibling.parentElement.closest(
                  ".collapse.menu-dropdown"
                );
              this.activateIconSidebarActive(
                "#" + grandparent.getAttribute("id")
              );
              grandparent.classList.add("show");
            }
          }
          this.activateIconSidebarActive(
            "#" +
              parentCollapseDiv.parentElement
                .closest(".collapse.menu-dropdown")
                .getAttribute("id")
          );

          parentCollapseDiv.parentElement
            .closest(".collapse")
            .classList.add("show");
          if (
            parentCollapseDiv.parentElement.closest(".collapse")
              .previousElementSibling
          )
            parentCollapseDiv.parentElement
              .closest(".collapse")
              .previousElementSibling.classList.add("active");
          return ;
        }
        this.activateIconSidebarActive(
          "#" + parentCollapseDiv.getAttribute("id")
        );
        return ;
      }
      return false;
    },
    activateIconSidebarActive(id) {
      let menu = document.querySelector(
        "#two-column-menu .simplebar-content-wrapper a[href='" +
          id +
          "'].nav-icon"
      );
      if (menu !== null) {
        menu.classList.add("active");
      }
    },
  },
};
</script>

<template>
  <BContainer fluid>
    <div id="two-column-menu"></div>

    <template v-if="layoutType === 'vertical' || layoutType === 'semibox'">
      <ul class="navbar-nav h-100" id="navbar-nav">
        <li
          class="nav-item"
          v-for="menuitem in menuItems"
          :key="menuitem.title"
        >
          <template v-if="menuitem.children">
            <b-link
              class="nav-link menu-link"
              data-bs-toggle="collapse"
              :href="menuitem.collapseitem"
              aria-expanded="false"
              aria-controls="sidebardashboards"
            >
             
              <font-awesome-icon v-if="menuitem.icon && isParent" :icon="getFaIcon(menuitem.icon)" />

              <span :data-Key="menuitem.title"> {{ menuitem.title }}</span>
            </b-link>
            <div class="collapse menu-dropdown" :id="menuitem.href">
              <ul class="nav nav-sm flex-column">
                <Menu :menuItems="menuitem.children" :isParent= false />
              </ul>
            </div>
          </template>
          <template v-else>
            <router-link
              :to="menuitem.route"
              class="nav-link"
              :data-key="menuitem.title"
            >
              <font-awesome-icon v-if="menuitem.icon && isParent" :icon="getFaIcon(menuitem.icon)" />
              <span> {{ menuitem.title }}</span>
            </router-link>
          </template>
        </li>
      </ul>
    </template>
  </BContainer>
</template>
